import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import dashboard_img from "../assets/images/dashboard_img.png";
import products_img from "../assets/images/products_img.png";
import orders_img from "../assets/images/orders_img.png";
import profile from "../assets/images/profile.jpg";
import filter_header_icon from "../assets/images/filter_header_icon.png";
import usersIcon from "../assets/images/users_icon.png";
import NotificationDropdown from "./NotificationDropdown";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.dispatchEvent(new Event("auth-changed"));
    setProfileMenuOpen(false);
    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileRef]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light shadow-sm header-nav mt-3 sticky-header">
      <div className="container d-flex justify-content-between align-items-center">
        <NavLink to="/dashboard" className="navbar-brand">
          <img src={logo} alt="Logo" className="logo logo-spacing" />
        </NavLink>

        <button className="navbar-toggler" type="button" onClick={toggleMenu}>
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          <div className="d-lg-flex align-items-center w-100 justify-content-between">
            <div className="navbar-nav d-flex flex-column flex-lg-row gap-4">
              <NavLink
                to="/dashboard"
                className="nav-link d-flex align-items-center"
                onClick={() => setIsOpen(false)}
              >
                <img src={dashboard_img} alt="Dashboard" className="me-1 " />
                Dashboard
              </NavLink>
              <NavLink
                to="/products"
                className="nav-link d-flex align-items-center"
                onClick={() => setIsOpen(false)}
              >
                <img src={products_img} alt="Products" className="me-1" />
                Products
              </NavLink>
              <NavLink
                to="/orders"
                className="nav-link d-flex align-items-center"
                onClick={() => setIsOpen(false)}
              >
                <img src={orders_img} alt="Orders" className="me-1" />
                Orders
              </NavLink>
              <NavLink
                to="/customers"
                className="nav-link d-flex align-items-center"
                onClick={() => setIsOpen(false)}
              >
                <img src={usersIcon} alt="Customers" className="me-1" style={{ width: "20px", height: "20px" }} />
                Customers
              </NavLink>
              {userRole !== "vendor" && (
                <>
                  <NavLink
                    to="/filters"
                    className="nav-link d-flex align-items-center"
                    onClick={() => setIsOpen(false)}
                  >
                    <img
                      src={filter_header_icon}
                      alt="Filters"
                      className="me-1"
                    />
                    Filters
                  </NavLink>
                  <NavLink
                    to="/attribute-pricing"
                    className="nav-link d-flex align-items-center"
                    onClick={() => setIsOpen(false)}
                  >
                    <img
                      src={filter_header_icon}
                      alt="Pricing"
                      className="me-1"
                    />
                    Attribute Pricing
                  </NavLink>
                  <NavLink
                    to="/agents"
                    className="nav-link d-flex align-items-center"
                    onClick={() => setIsOpen(false)}
                  >
                    Agents
                  </NavLink>
                  <NavLink
                    to="/agent-commission"
                    className="nav-link d-flex align-items-center"
                    onClick={() => setIsOpen(false)}
                  >
                    Agent Commission
                  </NavLink>
                </>
              )}
            </div>

            <div className="d-flex align-items-center gap-3 mt-3 mt-lg-0 position-relative" ref={profileRef}>
              <NotificationDropdown />
              <span className="fw-semibold" style={{ fontSize: '0.95rem', color: '#6b4f32' }}>
                {localStorage.getItem("userName") || "Admin"}
              </span>

              <div onClick={toggleProfileMenu} className="rounded-circle profile-img-wrapper" style={{cursor: "pointer"}}>
                <img src={profile} alt="Profile" className="rounded-circle" style={{ width: '40px', height: '40px', objectFit: 'cover' }} />
              </div>

              {profileMenuOpen && (
                <div className="position-absolute bg-white shadow rounded p-2" style={{ top: "40px", right: "0", width: "120px", zIndex: 1000 }}>
                  <NavLink
                    to="/profile"
                    className="d-block px-3 py-2 text-decoration-none text-dark"
                    onClick={() => setProfileMenuOpen(false)}
                  >
                    Profile
                  </NavLink>
                  <div
                    className="d-block px-3 py-2 text-decoration-none text-dark"
                    style={{cursor: "pointer"}}
                    onClick={handleLogout}
                  >
                    Logout
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;


